var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "duplicate" },
    [
      _c("div", { staticClass: "cont-box" }, [
        _c(
          "div",
          { staticClass: "title" },
          [
            _c("Title", { attrs: { text: "查重记录" } }),
            _c(
              "div",
              [
                _c(
                  "el-form",
                  {
                    ref: "search",
                    staticClass: "search-form",
                    attrs: {
                      slot: "search",
                      inline: true,
                      model: _vm.condition,
                      rules: _vm.searchRules,
                      "label-width": "80px",
                    },
                    slot: "search",
                  },
                  [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "justify-content": "space-between",
                        },
                      },
                      [
                        _c("div"),
                        _c("div", [
                          _c("div", { staticClass: "btn-box" }, [
                            _c(
                              "div",
                              [
                                _c(
                                  "el-form-item",
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        staticClass: "link-btn",
                                        attrs: { type: "primary" },
                                        on: { click: _vm.duplicateCheckClick },
                                      },
                                      [_vm._v("提交申请")]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]),
                        ]),
                      ]
                    ),
                  ]
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          [
            _c(
              "el-table",
              {
                attrs: {
                  data: _vm.list,
                  headerRowClassName: "uni-primary-table-header",
                  stripe: "",
                  border: "",
                },
              },
              [
                _c("el-table-column", {
                  attrs: {
                    prop: "student_title",
                    align: "center",
                    label: "学生姓名",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "paperviewurl",
                    align: "center",
                    label: "查重文件",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return _vm._l(
                          JSON.parse(row.files_url),
                          function (item, index) {
                            return _c(
                              "div",
                              { key: index },
                              [
                                _c(
                                  "el-button",
                                  {
                                    staticClass: "link-btn",
                                    attrs: { type: "text" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.seeFile(item.url, item.name)
                                      },
                                    },
                                  },
                                  [_vm._v(_vm._s(item.name))]
                                ),
                              ],
                              1
                            )
                          }
                        )
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "paperguid",
                    align: "center",
                    label: "检测报告编码",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "percentage",
                    align: "center",
                    label: "查重相似率",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "paperviewurl",
                    align: "center",
                    label: "在线预览链接",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return [
                          _c(
                            "a",
                            {
                              attrs: {
                                href: row.paperviewurl,
                                target: "_blank",
                              },
                            },
                            [_vm._v(_vm._s(row.paperviewurl))]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "paperdownurl",
                    align: "center",
                    label: "下载报告地址",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return [
                          _c(
                            "a",
                            {
                              attrs: {
                                href: row.paperdownurl,
                                target: "_blank",
                              },
                            },
                            [_vm._v(_vm._s(row.paperdownurl))]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: { align: "center", label: "操作", width: "200" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return [
                          _c(
                            "el-button",
                            {
                              staticClass: "link-btn",
                              attrs: { type: "text" },
                              on: {
                                click: function ($event) {
                                  return _vm.enterDetection(row)
                                },
                              },
                            },
                            [_vm._v("进入检测")]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _c(
        "el-dialog",
        {
          staticClass: "duplicateCheck",
          attrs: {
            title: "提交申请",
            visible: _vm.isShowDuplicateCheck,
            width: "40%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.isShowDuplicateCheck = $event
            },
            close: _vm.duplicateCheckClose,
          },
        },
        [
          _c(
            "div",
            { staticClass: "dialog" },
            [
              _c(
                "el-form",
                {
                  ref: "duplicateCheck",
                  attrs: {
                    model: _vm.duplicateCheckData,
                    rules: _vm.duplicateCheckRules,
                    "label-width": "160px",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "查重文件：", prop: "files_url" } },
                    [
                      _c("FalConUpload", {
                        ref: "uploadDuplicateCheck",
                        attrs: {
                          listStyle: "text",
                          accept: ".docx,.doc,.pdf,.txt",
                          limit: 1,
                          isFile: true,
                          isAccept: true,
                        },
                        on: {
                          handleRemove: _vm.duplicateCheckHandleRemove,
                          handleChange: _vm.duplicateCheckHandleChange,
                        },
                      }),
                      _c("div", [
                        _c("span", { staticClass: "tips" }, [
                          _vm._v(
                            "说明：查重文件只需要上传设计说明,只能上传docx,doc,pdf,txt文件"
                          ),
                        ]),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticStyle: { "text-align": "center" } },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.isShowDuplicateCheck = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    loading: _vm.duplicateCheckLoading,
                  },
                  on: { click: _vm.duplicateCheckSubmit },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }